
export default function WhoThisIsFor() {
  const members = [
    {
      icon: 'ri-user-star-line',
      title: 'Influencers & Models',
      description: 'Models, influencers, and individuals with strong visual presence and social following in Vancouver.'
    },
    {
      icon: 'ri-instagram-line',
      title: 'Socialites & Lifestyle Personalities',
      description: 'Online personalities, lifestyle socialites, and high-status individuals who shape culture and trends in the city.'
    },
    {
      icon: 'ri-goblet-line',
      title: 'Nightlife & Restaurant Elite',
      description: 'Venue owners, managers, bottle service professionals, and anyone with status in Vancouver\'s nightlife and hospitality scene.'
    },
    {
      icon: 'ri-music-line',
      title: 'Athletes & Musicians',
      description: 'Professional athletes, performing artists, DJs, and entertainment personalities with influence in Vancouver.'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Entrepreneurs & Executives',
      description: 'Successful business owners, investors, and high-level executives with real financial success which can be verified.'
    },
    {
      icon: 'ri-fire-line',
      title: 'The Well Connected',
      description: 'If you\'re recognized in Vancouver\'s social circles, have genuine influence, and people know your name - you belong here.'
    }
  ];

  return (
    <section id="who" className="relative bg-black px-6 py-32">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-amber-400/5 to-transparent" />
      
      <div className="relative mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <div className="mb-6 h-px w-24 mx-auto bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
          <h2 className="mb-6 font-serif text-4xl font-light text-white md:text-5xl lg:text-6xl">
            Who <span className="italic">This Is For</span>
          </h2>
          <p className="text-lg text-gray-400">
            Clique is built for Vancouver's most influential and well-connected individuals
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {members.map((member, index) => (
            <div 
              key={index}
              className="group border border-gray-800 bg-gradient-to-br from-gray-900 to-black p-8 transition-all duration-300 hover:border-amber-400 cursor-pointer"
            >
              <div className="mb-6 flex h-14 w-14 items-center justify-center border border-amber-400 bg-transparent">
                <i className={`${member.icon} text-2xl text-amber-400`}></i>
              </div>
              <h3 className="mb-4 text-xl font-medium text-white">
                {member.title}
              </h3>
              <p className="leading-relaxed text-gray-400">
                {member.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 border-l-4 border-amber-400 bg-gray-900 p-8 md:p-12">
          <p className="text-xl font-light leading-relaxed text-gray-300 md:text-2xl">
            If you have real status in Vancouver and want access to the city's most exclusive social scene -
            <span className="font-medium text-white"> &nbsp;Clique is for you.</span>
          </p>
        </div>
      </div>
    </section>
  );
}
